// extracted by mini-css-extract-plugin
export default {"getOutline":"Footer_getOutline__Coh2V","Footer":"Footer_Footer__MEpnh"};